import { FEATURE_NAMES } from '../../features/constants';

export const failedLoadResources = {
  enabled: false,
  auto_instrument: false,
  harvester: true,
  sampling: 1.0,
  features_required: [FEATURE_NAMES.sessionTrace],
  mapped_attributes: {
    metricSupport: ['css', 'img', 'link', 'script', 'other'],
    metadata: [],
  },
};
